// extracted by mini-css-extract-plugin
export default {"root":"n1yAhPaYH6_MYkg83y9n"};